import { Component, Input, OnInit } from '@angular/core';
import { GeometryObject } from 'geojson';
import { MapElement } from '../../shared/map/map-element.model';

@Component({
  selector: 'qm-element-hover',
  templateUrl: './element-hover.component.html',
  styleUrls: ['./element-hover.component.scss']
})
export class ElementHoverComponent {

  @Input()
  public selectedFeature: MapElement<GeometryObject>;

  public alwaysHiddenProperties = new Set([
    'alarms',
    'undefined',
    'uniqueBy',
    'labelBy',
    'text-anchor',
    'linkedStatus',
    'linkedValues',
    'linkedMinValue',
    'linkedMaxValue',
    'linkedText',
    'linkedOutOfBounds',
    'diffStatus',
    'diffResult',
  ]);

  constructor() { }

}
